module.exports = __webpack_public_path__ + "static/media/NewCaseSelectorPopupImage.c79fd523.png";